// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
import { Favorite, FavoriteBorder } from "@mui/icons-material";
import { Checkbox } from "@mui/material";
import React, { useEffect } from "react";
import { Text } from "../UI/generalLayout/Layout.styled";
import { ContainerCheckbox } from "./CheckBox.styled";
// --------------------------------------------------------

// --------------------------------------------------------
// CheckBox INTERFACE
// --------------------------------------------------------

interface ICheckBox {
  isDefault?: boolean;
  icon?: any;
  checkIcon?: any;
  title?: string;
  variavel?: string;
  isCheck?: any;
  isDisabled?: boolean;
  onClick: (value: any, active: boolean) => void;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
*/
const label = { inputProps: { "aria-label": "Checkbox demo" } };

const CheckBox = ({
  isDefault,
  icon,
  checkIcon,
  title,
  isCheck,
  variavel,
  isDisabled,
  onClick,
}: ICheckBox) => {
  // --------------------------------------------------------
  // CheckBox PRIVATE DECLARATIONS
  // --------------------------------------------------------
  // --------------------------------------------------------
  const [active, setActive] = React.useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setActive(event.target.checked);
    isCheck(event.target.checked);
  };

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <ContainerCheckbox>
      {!isDefault ? (
        <Checkbox
          checked={active}
          onChange={handleChange}
          {...label}
          defaultChecked
          disabled={isDisabled}
          onClick={() => onClick(variavel, active)}
        />
      ) : (
        <Checkbox
          {...label}
          checked={active}
          onChange={handleChange}
          icon={icon}
          checkedIcon={checkIcon}
          onClick={() => onClick(variavel, active)}
        />
      )}
      <Text>{title}</Text>
    </ContainerCheckbox>
  );
  // --------------------------------------------------------
};

export default CheckBox;
